import useLanguageQuery from "./useLanguageQuery";
import { PathLocales } from "../components/LocaleSelector";

const useLocalizedTags = (
  shouldShowBanner: boolean,
  pathLocales: PathLocales,
  locales: readonly string[],
  locale: string
) => {
  const languageData = useLanguageQuery();

  const tags =
    (shouldShowBanner &&
      pathLocales
        .filter((pathLocale) => locales.includes(pathLocale.locale))
        .map((pathLocale) => ({
          name: pathLocale.name,
          tagLocale: pathLocale.locale,
        }))) ||
    [];

  const currentLocaleTags = tags.map(({ name, tagLocale }) => ({
    locale: tagLocale,
    label: languageData
      .find((languageEntries) =>
        languageEntries.some((entry) => entry.value === name)
      )
      .find((entry) => entry.locale === locale).value,
  }));
  return currentLocaleTags;
};

export default useLocalizedTags;
